"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordRulesDescription = exports.PasswordRules = exports.PasswordRegexDescription = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * @Author: Fernando Schneider
 * @Date:   2024-05-02 09:40:37
 * @Last Modified by:   Fernando Schneider
 * @Last Modified time: 2024-05-02 09:47:57
 */

const PasswordRegexDescription = exports.PasswordRegexDescription = {
  EVERYTHING: 1,
  UPPER_LOWER_NUMBER_SYMBOL: 2,
  ONLY_ALPHANUMERIC: 3,
  MIN_8_CHARACTERS: 4,
  MIN_8_CHARACTERS_ALPHANUMERIC: 5,
  MIN_8_CHARACTERS_NUMBER_AND_SYMBOL: 6,
  MIN_8_CHARACTERS_WITH_UPPER_LOWER_NUMBER_SYMBOL: 7
};
const PasswordRules = exports.PasswordRules = {
  1: /.*/,
  2: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/,
  3: /^[A-Za-z0-9]{1,}$/,
  4: /^.{8,}$/,
  5: /^[A-Za-z0-9]{8,}$/,
  6: /^(?=.*\d)(?=.*[@$!%*?&]).{8,}$/,
  7: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).{8,}$/
};
const PasswordRulesDescription = exports.PasswordRulesDescription = {
  1: () => _reactIntlUniversal.default.get("EVERYTHING").d("Accepts all characters."),
  2: () => _reactIntlUniversal.default.get("UPPER_LOWER_NUMBER_SYMBOL").d("Includes uppercase, lowercase, number, and symbol."),
  3: () => _reactIntlUniversal.default.get("ONLY_ALPHANUMERIC").d("Only alphanumeric characters."),
  4: () => _reactIntlUniversal.default.get("MIN_8_CHARACTERS").d("At least 8 characters."),
  5: () => _reactIntlUniversal.default.get("MIN_8_CHARACTERS_ALPHANUMERIC").d("At least 8 alphanumeric characters."),
  6: () => _reactIntlUniversal.default.get("MIN_8_CHARACTERS_NUMBER_AND_SYMBOL").d("At least 8 characters with a number and symbol."),
  7: () => _reactIntlUniversal.default.get("MIN_8_CHARACTERS_WITH_UPPER_LOWER_NUMBER_SYMBOL").d("At least 8 characters, including uppercase, lowercase, number, and symbol.")
};